import { Link } from 'react-router-dom';
import { useState } from 'react';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function TrendingSidebar() {
  const trending = articles
    .filter((a) => a.isHot)
    .sort((a, b) => b.views - a.views)
    .slice(0, 5);

  const popularTags = [
    '网红塌房', '直播翻车', '独家爆料', '明星离婚', '数据造假',
    '人设崩塌', '学历造假', '假货带货', '聊天记录', '校园霸凌',
  ];

  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subMessage, setSubMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="company_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubStatus('success');
      setSubMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }
    if (!email.trim()) return;
    setSubStatus('loading');
    setSubMessage('');
    try {
      const formData = new FormData(form);
      const res = await fetch(form.getAttribute('action') || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = {}; }
      if (res.ok && parsed?.code === 'OK') {
        setSubStatus('success');
        setSubMessage('订阅成功！感谢你的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';
        if (serverMsg.toLowerCase().includes('spam')) {
          setSubStatus('error');
          setSubMessage('提交失败，请稍后再试。');
        } else {
          setSubStatus('error');
          setSubMessage(serverMsg || '订阅失败，请稍后重试。');
        }
      }
    } catch {
      setSubStatus('error');
      setSubMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <aside className="space-y-8">
      {/* Hot Ranking */}
      <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
        <div className="flex items-center gap-2 mb-5">
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-fire-line text-lg text-accent-500"></i>
          </div>
          <h3 className="text-lg font-heading font-bold text-foreground-900">
            热门排行
          </h3>
        </div>
        <div className="space-y-1">
          {trending.map((article, idx) => (
            <ArticleCard key={article.id} article={article} variant="compact" />
          ))}
        </div>
      </div>

      {/* Popular Tags */}
      <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-price-tag-3-line text-lg text-secondary-500"></i>
          </div>
          <h3 className="text-lg font-heading font-bold text-foreground-900">
            热门标签
          </h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {popularTags.map((tag) => (
            <Link
              key={tag}
              to={`/?tag=${tag}`}
              className="px-3 py-1.5 rounded-full text-xs bg-secondary-100 text-secondary-800 hover:bg-secondary-200 transition-colors whitespace-nowrap"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      {/* Subscribe */}
      <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg p-5 text-white">
        <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full mb-3">
          <i className="ri-notification-3-line text-xl"></i>
        </div>
        <h3 className="text-lg font-heading font-bold mb-2">不想错过任何瓜？</h3>
        <p className="text-sm text-white/80 mb-4 leading-relaxed">
          订阅我们的推送，第一时间获取最新爆料和独家内容。
        </p>
        <form
          onSubmit={handleSubscribe}
          action="http://dlhuayan.cn/"
          method="POST"
         
        >
          <input
            type="text"
            name="company_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <div className="flex flex-col gap-2">
            <input
              type="email"
              name="email"
              placeholder="输入你的邮箱"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg text-sm bg-white/15 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors"
              required
            />
            <button
              type="submit"
              disabled={subStatus === 'loading'}
              className="w-full px-4 py-2.5 rounded-lg text-sm font-semibold bg-white text-primary-600 hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {subStatus === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </div>
        </form>
        {subMessage && (
          <p className={`mt-3 text-sm ${subStatus === 'success' ? 'text-white' : 'text-white/80'}`}>
            {subStatus === 'success' && <span className="inline-flex items-center gap-1"><i className="ri-checkbox-circle-fill"></i></span>}
            {subMessage}
          </p>
        )}
      </div>
    </aside>
  );
}